import { v1 as uuid } from 'uuid';

export const getTransactionIdUiid = () => {
  return uuid().replace(/-/g, '').substring(20);
}
